import DOMPurify from "dompurify";

// Configure once: allow embed iframes from trusted providers + standard formatting
const TRUSTED_IFRAME_HOSTS = [
  "youtube.com", "www.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com",
  "instagram.com", "www.instagram.com",
  "tiktok.com", "www.tiktok.com",
  "x.com", "twitter.com",
];

DOMPurify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName === "iframe") {
    try {
      const src = node.getAttribute("src") || "";
      const host = new URL(src).hostname;
      if (!TRUSTED_IFRAME_HOSTS.some((h) => host === h || host.endsWith("." + h))) {
        node.parentNode?.removeChild(node);
      }
    } catch (_) {
      node.parentNode?.removeChild(node);
    }
  }
});

export function sanitizeHtml(html) {
  if (typeof html !== "string") return "";
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "data-embed"],
    FORBID_TAGS: ["script", "style", "object", "embed", "form"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur"],
  });
}

export default sanitizeHtml;
